var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSaturn = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.07 12.6C17.8848 11.6934 17.4373 10.8613 16.783 10.207C16.1287 9.5527 15.2966 9.10516 14.39 8.92C13.6307 8.76087 12.8461 8.766 12.089 8.93502C11.3318 9.10405 10.6195 9.43307 10 9.9V7H13V5H10V2H8V5H5V7H8V21H10V12.64C10.4229 11.9885 11.0263 11.4741 11.7366 11.1598C12.4469 10.8455 13.2334 10.7448 14 10.87C14.5199 10.981 14.9959 11.2419 15.3691 11.6204C15.7423 11.999 15.9964 12.4786 16.1 13C16.39 14.56 15.25 16.32 12.97 17.83L11.97 18.52L15.35 21.75L16.73 20.31L15.12 18.77C17.38 16.89 18.46 14.7 18.07 12.6Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSaturn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/saturn.586c4c4f7c4020edfd1a8eec95bf8886.svg";